import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import CoefficiantTable from './CeofficiantAbattement/CoefficiantTable';
import CoeffRelatifTable from './CoefficiantRelatif/CoeffRelatifTable';
import { Accordion, AccordionBody, AccordionHeader, AccordionItem, Container } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import ValeurVinalTable from './ValeurVinal/valeurVinalTable';
import { dataActions } from '../dataSlice';

const Parametrage = () => {
  const { t } = useTranslation('translation');
  const { isFetching, categVH } = useSelector(state => state.data);

  const breadcrumbItems = [
    { title: t('param'), link: "#" },
    { title: t('param'), link: "#" }
  ];

  const dispatch = useDispatch();

  useEffect(() => {
    if(categVH.length == 0) {
      dispatch(dataActions.loadData())
    }
  }, [])

  const [open, setOpen] = useState('1');
  const toggle = (id) => {
    if (open === id) {
      setOpen();
    } else {
      setOpen(id);
    }
  };

  return (
    <React.Fragment>
      {isFetching ? <div id="preloader">
        <div id="status">
          <div className="spinner">
            <i className="ri-loader-line spin-icon"></i>
          </div>
        </div>
      </div> :
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title={t('param')} breadcrumbItems={breadcrumbItems} />
          <Accordion open={open} toggle={toggle}>
            <AccordionItem>
              <AccordionHeader targetId="1">{t('parametrage.section1')}</AccordionHeader>
              <AccordionBody accordionId="1">
                <ValeurVinalTable />
              </AccordionBody>
            </AccordionItem>
            <AccordionItem>
              <AccordionHeader targetId="2">{t('parametrage.section2')}</AccordionHeader>
              <AccordionBody accordionId="2">
                <CoefficiantTable />
              </AccordionBody>
            </AccordionItem>
            <AccordionItem>
              <AccordionHeader targetId="3">{t('parametrage.section3')}</AccordionHeader>
              <AccordionBody accordionId="3">
                <CoeffRelatifTable />
              </AccordionBody>
            </AccordionItem>
          </Accordion>
        </Container>
      </div>}
    </React.Fragment >
  )
}

export default Parametrage;